<template>
  <v-main>
    <v-btn @click="triggerFullscreen">Fullscreen</v-btn>
    <div v-if="!openVeiwLucky">
      <div>
        <v-img width="450" :class="{ 'slide-right': slideRight, 'slide-left': slideLeft }" style="position: absolute;left: 10px;top: 30px;" :src="require('../../assets/name 1.png')"></v-img>
      </div>
      <div v-if="!randomed" @click="viewLucky">
        <v-img width="60"  style="position: absolute;right: 100px;top: 70px;" :src="require('../../assets/Vector.png')"></v-img>
      </div>
      <div>
        <div class="circle-container-wrapper">
          <img
              :src="require('../../assets/Frame 100.png')"
              alt="John"
              style="height: 320px;"
              class="background-image"
              :style="getCircleItemStyle2()"
            >
          <div class="circle-container" :class="{ 'animate': isAnimating }">
            <div
              v-for="(item, index) in items"
              :key="index"
              class="circle-item"
              :style="getCircleItemStyle(index)"
            >
              <div v-if="index === 0">
                <v-avatar size="150" stlye="" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                  <img
                    :src="require('../../assets/Ellipse 102.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 1" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 110.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 2" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 106.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 3" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 100.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 4" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 108.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 5" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 98.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 6" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 99.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 7" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 118.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 8" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 119.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 9" >
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 121.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 10" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 123.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <div v-if="index === 11" :class="{ 'fade-out': fadeOut, 'fade-In': !fadeOut  }">
                <v-avatar size="150" stlye="">
                  <img
                    :src="require('../../assets/Ellipse 125.png')"
                    alt="John"
                  >
                </v-avatar>
              </div>
              <!-- <div v-else>{{ index + 1 }}</div> -->
            </div>
          </div>
          <div class="center-button" :class="{ 'slide-top': slideTop, 'slide-down': slideDown }">
            <!-- <div  @click="startAnimation"></div> -->
            <div class="slot-machine">
                <ul class="slot-list" :class="{ running: isRunning }">
                  <li v-for="(r, index) in slots" :key="`${r.id}-${index}`">
                    <div class="slot-text" v-if="actionText !== 'Random'">
                      <div>{{ r.reallyName }}</div>
                      <div> {{ r.team }}</div>
                    </div>
                  </li>
                </ul>
              </div>

              <div class="trigger" @click="runSlots" :disabled="isRunning">
                {{ actionText }}
              </div>
            </div>
            <div style="display: flex;position: absolute;top: 110px;" :class="{ 'slide-top2': slideTop2 }" v-if="reset">
              <v-img width="90"  class="mr-7" :src="require('../../assets/Frame 75.png')"  @click="resetRandom"></v-img>
              <v-img width="60" @click="viewLucky" :src="require('../../assets/Vector.png')"></v-img>
            </div>
          </div>
      </div>
    </div>
    <div v-if="openVeiwLucky">
      <!-- <div>
        <v-img width="450" style="position: absolute;left: 10px;top: 15px;" :src="require('../../assets/name 1.png')"></v-img>
        <v-img width="60"  style="position: absolute;right: 100px;top: 70px;" @click="openVeiwLucky = false" :src="require('../../assets/Frame 75.png')"></v-img>
      </div> -->
      <div>
        <v-img width="450"  :src="require('../../assets/name 1.png')"></v-img>
        <v-img width="60" style="position: absolute;right: 100px;top: 70px;"  @click="openVeiwLucky = false" :src="require('../../assets/Frame 75.png')"></v-img>
      </div>
      <div class="pa-8">
        <v-row >
          <v-col class="slot-text" style="margin-bottom: 70px;" cols="6" v-for="(item, i) in pastSelections" :key="i">
            <div class="nameList">
              <p class="mb-0" style="color: white;">{{ item.reallyName }}</p>
              <p class="mb-0" style="color: white;">{{ item.team }}</p>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-main>
</template>

<script>
export default {
  name: 'CircleGroup',
  data () {
    return {
      isRunning: false,
      selectedIndex: 0,
      selectedRestaurant: null,

      pastSelections: [{'id': 2,
        'reallyName': 'Jenny',
        'team': 'Alibaba' }],
      slots: [],
      randomed: false,
      slideRight: false,
      slideLeft: false,
      slideTop: false,
      slideDown: false,
      fadeOut: false,
      actionText: 'Random',
      reset: false,
      restaurants: [
        {'id': 1,
          'reallyName': 'Jenny',
          'team': 'Faceline' },
        {'id': 2,
          'reallyName': 'ddd',
          'team': 's' }
      ],
      openVeiwLucky: false,
      hideRandomText: false,
      items: new Array(12).fill(0), // Array of 10 items
      radius: 560, // Radius of the circle
      isAnimating: false // State to control animation
    }
  },
  async mounted () {
    await this.triggerFullscreen()
  },
  methods: {
    triggerFullscreen () {
      const elem = document.getElementById('bg')
      if (elem.requestFullscreen) {
        elem.requestFullscreen().catch(err => {
          console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
        })
      } else if (elem.mozRequestFullScreen) { // Firefox
        elem.mozRequestFullScreen().catch(err => {
          console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
        })
      } else if (elem.webkitRequestFullscreen) { // Chrome, Safari and Opera
        elem.webkitRequestFullscreen().catch(err => {
          console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
        })
      } else if (elem.msRequestFullscreen) { // IE/Edge
        elem.msRequestFullscreen().catch(err => {
          console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
        })
      }
    },
    viewLucky () {
      this.openVeiwLucky = true
    },
    resetRandom () {
      this.fadeOut = false
      this.reset = false
      this.slideTop = false
      this.slideDown = true
      this.slideRight = false
      this.slideLeft = true
      this.randomed = false
      this.actionText = 'Random'
    },
    getCircleItemStyle2 () {
      // const totalItems = this.items.length
      // const angle = (9 / totalItems) * 360 // Calculate angle in degrees
      // const x = this.radius * Math.cos((angle * Math.PI) / 180) // X position
      // const y = this.radius * Math.sin((angle * Math.PI) / 180) // Y position

      return {
        transform: `translate(-1.0287e-13px, -633px)` // Position in a circle
      }
    },
    // Calculate the position of each circle item around the circle
    getCircleItemStyle (index) {
      const totalItems = this.items.length
      const angle = (index / totalItems) * 360 // Calculate angle in degrees
      const x = this.radius * Math.cos((angle * Math.PI) / 180) // X position
      const y = this.radius * Math.sin((angle * Math.PI) / 180) // Y position

      return {
        transform: `translate(${x}px, ${y}px)` // Position in a circle
      }
    },
    runSlots () {
      this.actionText = ''
      this.isAnimating = true
      this.randomed = true
      this.slideLeft = false

      setTimeout(() => {
        this.isAnimating = false
      }, 5000)
      // clear the selected restaurant
      this.selectedRestaurant = null
      // get the last item in past selections
      const lastSelected = this.pastSelections[this.pastSelections.length - 1]
      // filter out any items from the restaurant array that are in the past selections array
      let slotsArray = this.restaurants.filter(
        (it) => !this.pastSelections.find((past) => past.id === it.id)
      )
      // get a randowm index from the slots array
      const selectedIndex = Math.floor(Math.random() * slotsArray.length)
      // get a version of the slots array trimmed to the selected restaurant
      const trimmedSlotsArray = slotsArray.slice(0, selectedIndex + 1)
      // build out the scrolling list
      let scrollSlotsArray = [...slotsArray, ...slotsArray]
      // if there is a last selected item, add it to the beginning of the list so the animation doesn't jump
      if (lastSelected) scrollSlotsArray = [lastSelected, ...scrollSlotsArray]
      // set the slots array for the UI
      this.slots = [...scrollSlotsArray, ...trimmedSlotsArray]
      // run the animation
      this.isRunning = true
      // after the animation is done, set the selected restaurant, push to past selections, reset the slots array, and stop the animation
      setTimeout(() => {
        this.selectedRestaurant = slotsArray[selectedIndex]
        this.pastSelections.push(this.selectedRestaurant)
        this.slots = [this.selectedRestaurant]
        this.isRunning = false
        this.slideRight = true
        this.slideTop = true
        this.slideDown = false
        this.slideTop2 = true
        this.fadeOut = true
        this.reset = true
      }, 3000)
    },
    // Method to start the animation
    startAnimation () {
      this.runSlots()
      this.isAnimating = true

      setTimeout(() => {
        this.isAnimating = false
      }, 5000)
    }
  }
}
</script>

<style scoped>
.circle-container-wrapper {
  position: relative;
  width: 500px;
  height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: -100px; /* Adjust this value as needed */
  left: 50%;
  transform: translateX(-50%);
  bottom: -900px;
}

.circle-container {
  position: absolute;
  width: 500px; /* Increased width as needed */
  height: 500px; /* Increased height as needed */
  border-radius: 50%; /* Ensure it's a circle */
  display: flex;
  justify-content: center;
  align-items: center;
}

.circle-item {
  width: 50px; /* Adjust size of the circle item */
  height: 50px; /* Adjust size of the circle item */
  border-radius: 50%; /* Ensure it's a circle */
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  color: white; /* Text color */
}

.center-button {
  padding: 40px;
  font-size: 80px;
  background-color: #9122b623;
  border: solid, #c238a1 !important;
  border-radius: 100px !important;
  position: absolute;
  top: -80px;
  backdrop-filter: blur(10px);
  width: 650px; /* Adjust width as needed */
  height: 171px; /* Adjust height as needed */
  color: white; /* Text color */
  border: none; /* Remove border */
  border-radius: 5px; /* Rounded corners */
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer; /* Pointer cursor on hover */
  z-index: 1; /* Ensure button is on top of circle items */
}

.bg {
  background-image: url("../../assets/Banner.png");
  background-size: cover;
  overflow-y: hidden;
}

.background-image {
  position: absolute;
  z-index: -1; /* Send background image to the back */
}

/* Define keyframes for animation */
@keyframes rotateContainer {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.slot-machine {
  height: 8rem;
  overflow: hidden;
  position: relative;
}
.slot-list {
  list-style: none;
  margin: 0;
  padding: 0;
  transition: 0s;
}
.slot-text {
  background: transparent;
  border: none;
  display: grid;
  font-size: 40px;
  font-weight: 200;
  height: 8rem;
  margin: 0;
  place-content: center;
  padding: 0;
  text-align: center;
  width: 100%;
}
.running {
  transform: translateY(calc(-100% + 8rem));
  transition: 2s cubic-bezier(0.19, 0.97, 0.5, 1.005);
}
.starter {
  color: var(--primary-light);
}
/* Apply animation when the 'animate' class is added */
.animate {
  animation: rotateContainer 1.5s linear;
}
@keyframes slideRight {
  from {
    left: 0%;
    transform: translateX(0%);
  }
  to {
    left: 50%;
    transform: translateX(-50%);
  }
}

.slide-right {
  animation: slideRight 1s forwards;
}

@keyframes slideLeft {
  from {
    left: 50%;
    transform: translateX(-50%);
  }
  to {
    left: 0%;
    transform: translateX(0%);
  }
}

.slide-left {
  animation: slideLeft 1s forwards;
}

.slide-top {
  animation: slideTop 1s forwards;
}

@keyframes slideTop {
  from {
    top: 0;
  }
  to {
    top: -200px;
  }
}

.slide-down {
  animation: slideDown 1s forwards;
}

@keyframes slideDown {
  from {
    top: -200px;
  }
  to {
    top: 0;
  }
}

.slide-top2 {
  animation: slideTop2 1s forwards;
}

@keyframes slideTop2 {
  from {
    top: 0;
  }
  to {
    top: -10px;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fade-out {
  animation: fadeOut 2s forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.nameList {
  width: 800px;
  padding: 20px 150px;
  background-color: #9122b623;
  border: 1px solid #c238a1;
  border-radius: 100px;
  box-shadow:
    inset 0 2px 4px rgba(0, 0, 0, 0.6), /* inner shadow */
    0 0 15px rgba(0, 0, 0, 0.3); /* outer shadow */
  backdrop-filter: blur(20px);
  color: white;
  text-align: center;
  position: relative;
  z-index: 1;
}
/* .fade-In-div {
  animation: fadeIn 2s forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fade-In {
  animation: fadeIn 2s forwards;
} */
</style>



// WEBPACK FOOTER //
// src/components/Tool/Random.vue